import { createAction } from "@reduxjs/toolkit"
import { BuildEntityParams, CalculationProcessStep } from "store/types/assembler"

export const assemblerConstants = {
    SAGA_BUILD_ASSEMBLY: "SAGA_BUILD_ASSEMBLY",
    SAGA_GET_SEARCH_RESULTS: "SAGA_GET_SEARCH_RESULTS",
    SAGA_GET_SINGLE_ENTITY: "SAGA_GET_SINGLE_ENTITY",
    SAGA_GET_ASSEMBLY_LISTING: "SAGA_GET_ASSEMBLY_LISTING",
    SAGA_GET_ASSEMBLY: "SAGA_GET_ASSEMBLY",
    SAGA_CREATE_ASSEMBLY: "SAGA_CREATE_ASSEMBLY",
    SAGA_SAVE_ASSEMBLY: "SAGA_SAVE_ASSEMBLY",
    SAGA_DELETE_ASSEMBLY: "SAGA_DELETE_ASSEMBLY",
    SAGA_RENAME_ASSEMBLY: "SAGA_RENAME_ASSEMBLY",
    SAGA_GET_PREMADE_ASSEMBLY: "SAGA_GET_PREMADE_ASSEMBLY",
    SAGA_GET_VARIANTS: "SAGA_GET_VARIANTS"
    }

export const  sagaBuildAssemblyAction = () => {
    return { type: assemblerConstants.SAGA_BUILD_ASSEMBLY
    }
}


export const sagaGetSearchResultsAction = (contextName?: string) => {
  return {
    type: assemblerConstants.SAGA_GET_SEARCH_RESULTS,
    payload: contextName,
  };
};

export const  sagaGetAssemblyListingAction = () => {
    return { type: assemblerConstants.SAGA_GET_ASSEMBLY_LISTING
    }
}


// Example: typed action that includes sid & country
export const sagaGetSingleEntityAction = createAction<{
    sid: string;
    country?: string;
    deliveryShapes?: string;
  }>(assemblerConstants.SAGA_GET_SINGLE_ENTITY);

  export const sagaGetAssemblyAction = createAction<{
    uuid: string;
  }>(assemblerConstants.SAGA_GET_ASSEMBLY);


    export const sagaGetPreMadeAssemblyAction = createAction<{
    sid: string, p:BuildEntityParams;
  }>(assemblerConstants.SAGA_GET_PREMADE_ASSEMBLY);

export const sagaGetVariantsAction = createAction<{
  sid: string
}>(assemblerConstants.SAGA_GET_VARIANTS)

  export const sagaDeleteAssemblyAction = createAction<{
    uuid: string;
  }>(assemblerConstants.SAGA_DELETE_ASSEMBLY);


  
export const sagaCreateAssemblyAction = createAction<{
    name: string;
    calculationProcessChain?: CalculationProcessStep[]
  }>(assemblerConstants.SAGA_CREATE_ASSEMBLY);

  export const sagaSaveAssemblyModelAction = createAction<{
    uuid: string;
  }>(assemblerConstants.SAGA_SAVE_ASSEMBLY);


  export const sagaRenameAssemblyAction = createAction<{
    uuid: string;
    name: string
  }>(assemblerConstants.SAGA_RENAME_ASSEMBLY);